import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "./../middleware/Auth";

function page(path) {
    return () =>
        import (`../views/${path}`).then(m => m.default || m);
}

Vue.use(VueRouter);

const routes = [
    {
      path: "/admin",
      name: "TeacherList",
      meta: {
        layout: "AppLayout"
      },
      component: page("TeacherList")
    },
    {
      path: "/",
      name: "",
      meta: {
        layout: "AppLayout"
      },
    },
    {
        path: "/admin/config/difficulty",
        name: "Difficulty",
        meta: {
            layout: "AppLayout"
        },
        component: page("Config/Difficulty.vue")
    },
    {
        path: "/admin/config/category",
        name: "Category",
        meta: {
            layout: "AppLayout"
        },
        component: page("Config/Category.vue")
    },
    {
      path: "/admin/group-topic-list",
      name: "GroupTopicList",
      meta: {
          layout: "AppLayout"
      },
      component: page("GroupTopic/GroupTopicList.vue")
    },
    {
        path: "/admin/exam/list",
        name: "ExamList",
        meta: {
            layout: "AppLayout"
        },
        component: page("Exam/List.vue")
    },
    {
        path: "/admin/config/grade",
        name: "Grade",
        meta: {
            layout: "AppLayout"
        },
        component: page("Config/Grade.vue")
    },
    {
        path: "/admin/config/logo",
        name: "SetTimes",
        meta: {
            layout: "AppLayout"
        },
        component: page("Config/Logo.vue")
    },
    {
        path: "/admin/question-list/question",
        name: "QuestionList",
        meta: {
            layout: "AppLayout"
        },
        component: page("QuestionList/QuestionList.vue")
    },
    {
        path: "/admin/about",
        name: "About",
        meta: {
            layout: "AppLayout"
        },
        component: page("About")
    },
    {
        path: "/admin/login",
        name: "Login",
        meta: {
            layout: "AuthLayout"
        },
        component: page("Login.vue")
    },
    {
        path: "/login",
        name: "LoginStudent",
        meta: {
            layout: "AuthLayout"
        },
        component: page("Login/LoginStudent.vue")
    },
    {
        path: "/forgot",
        name: "Forgot",
        meta: {
            layout: "AuthLayout"
        },
        component: page("Forgot")
    },
    {
        path: "/send-code",
        name: "SendCode",
        meta: {
            layout: "AuthLayout"
        },
        component: page("SendCode")
    },
    {
        path: "/signup",
        name: "Signup",
        meta: {
            layout: "AuthLayout"
        },
        component: page("Signup")
    },
    {
        path: "/profile",
        name: "Profile",
        meta: {
            layout: "AppLayout"
        },
        component: page("Profile")
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        meta: {
            layout: "AuthLayout"
        },
        component: page("ResetPassword")
    },
    //User
    {
        path: "/user/problem-detail/:id",
        name: "UserProblemDetail",
        meta: {
            layout: "AppLayout"
        },
        component: page("ProblemDetail")
    },

    //Admin
    {
        path: "/admin/category",
        name: "categories.index",
        meta: {
            layout: "AppLayout"
        },
        component: page("Category/Category")
    },
    {
        path: "/admin/category/create",
        name: "categories.create",
        meta: {
            layout: "AppLayout"
        },
        component: page("Category/CategoryCreate")
    },
    {
        path: "/admin/category/edit/:id",
        name: "categories.edit",
        meta: {
            layout: "AppLayout"
        },
        component: page("Category/CategoryEdit")
    },
    {
        path: "/admin/problem",
        name: "AdminProblem",
        meta: {
            layout: "AppLayout"
        },
        component: page("List/ListProblem")
    },
    {
        path: "/admin/problem/create",
        name: "CreateProblem",
        meta: {
            layout: "AppLayout"
        },
        component: page("Problem/ProblemCreate")
    },
    {
        path: "/admin/problem/edit/:id",
        name: "EditProblem",
        meta: {
            layout: "AppLayout"
        },
        component: page("Problem/ProblemEdit")
    },
    {
        path: "/admin/user-answer/list",
        name: "ListUserAnswer",
        meta: {
            layout: "AppLayout"
        },
        component: page("List/ListUserAnswer")
    },
    {
        path: "/admin/user-answer/detail/:id",
        name: "DetailUserAnswer",
        meta: {
            layout: "AppLayout"
        },
        component: page("DetailUserAnswer")
    },
    {
        path: "/admin/list-user",
        name: "ListUser",
        meta: {
            layout: "AppLayout",
            middleware: [Auth]
        },
        component: page("List/ListUser")
    },
    {
        path: "/fobidden",
        meta: {
            layout: "AppLayout"
        },
        name: "403",
        component: page("Error/403")
    },
    {
        path: "*",
        meta: {
            layout: "AppLayout"
        },
        name: "404",
        component: page("Error/404")
    },
    {
        path: "/student/exam/list",
        meta: {
            layout: "AppLayout"
        },
        name: "ExamStudent",
        component: page("ExamStudent/ExamStudent.vue")
    },
    {
        path: "/admin/exam/papers-list",
        meta: {
            layout: "AppLayout"
        },
        name: "ListPapers",
        component: page("Exam/ListPapers.vue")
    },
    {
        path: "/admin/exam/student-list",
        meta: {
            layout: "AppLayout"
        },
        name: "ExamStudentList",
        component: page("Exam/ExamStudentList.vue")
    },
    {
        path: "/admin/exam/student-detail",
        meta: {
            layout: "AppLayout"
        },
        name: "ExamStudentDetail",
        component: page("Exam/ExamStudentDetail.vue")
    },
    {
        path: "/admin/exam/student-result",
        meta: {
            layout: "AppLayout"
        },
        name: "ExamStudentResult",
        component: page("Exam/ExamStudentResult.vue")
    },
    {
        path: "/admin/exam/student-result-detail",
        meta: {
            layout: "AppLayout"
        },
        name: "ExamStudentResultDetail",
        component: page("Exam/ExamStudentResultDetail.vue")
    },
    {
        path: "/student/exam/my-exam",
        meta: {
            layout: "AppLayout"
        },
        name: "MyExam",
        component: page("ExamStudent/MyExam.vue")
    },
    {
        path: "/student/exam/my-exam/result",
        meta: {
            layout: "AppLayout"
        },
        name: "MyExamResult",
        component: page("ExamStudent/ExamResult.vue")
    },
    {
        path: "/student/exam/try-exam",
        meta: {
            layout: "AppLayout"
        },
        name: "TryExam",
        component: page("ExamStudent/TryExam")
    },
    {
        path: "/student/exam/buy-exam",
        meta: {
            layout: "AppLayout"
        },
        name: "BuyExam",
        component: page("ExamStudent/BuyExam")
    },
    {
        path: "/student/exam/my-cart",
        meta: {
            layout: "AppLayout"
        },
        name: "MyCart",
        component: page("ExamStudent/MyCart")
    },
    {
        path: "/student/exam/buy-exam/vnpay",
        meta: {
            layout: "AppLayout"
        },
        name:"VNPay",
        component: page("ExamStudent/PaymentMethods/VNPay")
    },
    {
        path: "/student/exam/buy-exam/momo",
        meta: {
            layout: "AppLayout"
        },
        name:"Momo",
        component: page("ExamStudent/PaymentMethods/Momo")
    },
    {
        path: "/admin/payment",
        meta: {
            layout: "AppLayout"
        },
        name:"Payment",
        component: page("Config/Payment")
    },
    {
        path: "/verify",
        meta: {
          layout: "AuthLayout"
        },
        name: "Verify",
        component: page("Login/Verify")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

/**
 * Global middlware
 *
 * @return {Array}
 */
function globalMiddleware() {
    return [Auth];
}

/**
 * Each a middleware
 *
 * @return {void}
 */
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    let middleware = null;
    let routeMiddleware = null;

    if (to.meta.middleware) {
        routeMiddleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];
    }
    middleware = routeMiddleware ?
        globalMiddleware().concat(routeMiddleware) :
        globalMiddleware();

    if (middleware.length > 0) {
        const context = { to, from, next, router };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({...context, next: nextMiddleware });
    }

    return next();
});

export default router;
